module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page07"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Chapter One")])])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page07"
    }
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "chapterOpenerFirstLetters"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("H")])]), _vm._v("e missed them.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Kevin Quintano carefully placed the framed eight-by-ten photograph he’d been looking at for the past ten minutes back on his coffee table and sighed. He could almost hear the laughter in that photograph, taken at Jimmy’s graduation from medical school. It was of the four of them. Alison, Lily, Jimmy and him.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He truly missed them.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Missed the sound of their voices, missed the good-natured bickering between his younger siblings that he’d once thought would send him up a wall. Missed life the way it used to be.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page07"
    }
  }, [_vm._v("There were times when the silence became over")]), _c('a', {
    attrs: {
      "id": "page08"
    }
  }, [_vm._v("whelming. To get away from it, he’d turned on a radio or a television set in every room of the house, just to hear people talking, just to see images.")])]), _c('a', {
    attrs: {
      "id": "page08"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But the silence wasn’t the worst of it. The loneliness was.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("You’d think now, at thirty-seven, with no debts and more money than he knew what to do with, for the very first time in his life he’d kick back and enjoy himself.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Damn, Kevin, you can live the high life now,” Nathan had said enviously at his recent farewell party. The big, strapping black man and the other cab drivers who used to work for him had come together and thrown a party just for him.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Trouble was, Kevin mused, moving into the kitchen to prepare a lunch he had no desire to eat, he had neither wanted the high life, nor known what to do with it should he ever wind up stumbling across it.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("What he wanted was the busy life. The life that barely gave him enough time to draw two breaths together in succession.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Kevin stared into the refrigerator. It was nearly empty. He’d forgotten to go grocery shopping. Again. Lily used to take care of that for him because he was always too busy to do it himself.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Too busy.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page08"
    }
  }, [_vm._v("That’s the way it had been ever since he’d turned seventeen and, through some creative doctoring of his ")]), _c('a', {
    attrs: {
      "id": "page09"
    }
  }, [_vm._v("birth certificate, had gotten himself placed in charge of his orphaned brother and sisters. Overnight he’d become both mother and father to three kids without the comforting benefit of having a spouse or ever having procreated.")])]), _c('a', {
    attrs: {
      "id": "page09"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And now, he thought, he was experiencing the empty-nest syndrome under the same set of circumstances.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Big time.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("That was probably why, in a moment of weakness—because Nathan and Joe had talked him into thinking that perhaps a huge change might shake him out of his doldrums—he’d sold his taxicab service. The very same service that had seen his fledgling family through the hard times. The same service that had allowed him to put food on the table and take out a loan so that Jimmy could go to medical school and graduate as something more than a pauper with an incredible debt to repay.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It was Kevin who had shouldered the debt. And he who’d been so damn proud of his brother at graduation.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("In its time, the taxicab service had also allowed him to put Alison, the baby of the family, through nursing school and to set Lily up in her very first restaurant when they’d all decided that she had an incredible gift for creating meals but no capacity for taking orders.")])]), _c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And where had all that loan-incurring finally gotten him?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Alone, that’s where.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Alone while the rest of them, the three people who mattered most in his life, had gone off, one by one, to live in Alaska, in some godforsaken place aptly labeled Hades.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Hell.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Wandering back into the living room, Kevin dropped down into the sofa and stared blankly at a woman trying vainly to escape a horde of rampaging twelve-foot spiders. Midday programs were hellish, too.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("That was where he felt he was right now. In hell. And he’d discovered something these past few weeks. It wasn’t fire and brimstone that created a hell, it was bare-bones loneliness. Loneliness comprised of slick, glasslike walls that sent him sliding back to the ground no matter how quickly he tried to scale them.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He knew he should be proud of his siblings and the selflessness they’d exhibited to varying degrees. Alison had gone first, because Hades needed a nurse and she needed to get certified as a nurse-practitioner by putting time in a place like that.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Only problem was, she’d put in her heart as well and so had remained.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_vm._v("When Jimmy had gone to visit her, he’d lost his heart as well. Not to the region, but to April Yearling, the granddaughter of Hades’s postmistress. Hades and ")]), _c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_vm._v("the surrounding region badly needed another doctor and Jimmy had found his true calling.")])]), _c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Lily’s broken engagement had brought her to the same place to recover, Alaska being the only place that could withstand the heat of her anger without frying to a crisp. Intending to stay only two weeks, Lily found solace for her wounded pride and chipped heart with Hades sheriff, Max Yearling, who just happened to be April’s brother.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It was as if the Fates were conspiring to bring his family to a place that spent six months of every year in a deep freeze, cut off from civilization except by air travel.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Kevin had thought—hoped—that Alaska might be a passing phase with Lily. Lily had always been the mercurial one, the one who never invested her emotions for fear of being hurt. But this time, she apparently was sticking it out, and the last time he’d spoken to her, she’d said something about bringing real food to the residents of Hades and had her eye on opening a restaurant there. He knew the signs by now. Lily, like Alison and Jimmy before her, was settling in for good.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Unable to watch the giant spiders destroy yet another campsite and assorted campers, Kevin flipped the channel. The afternoon news looked no less disconcerting. He dropped the remote on the table, giving up.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The restlessness refused to abate.")])]), _c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It was this restlessness that had made him so susceptible to Nathan and Joe’s suggestion about selling the cab service. He’d done it on a lark, put the business up for sale. His heart hadn’t really been in it. And then that offer had come in. The one he couldn’t refuse without submitting himself to a sanity hearing because it was so incredibly lucrative.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("So here he was, a man of leisure who knew absolutely nothing about taking it easy except what he’d learned lately, which was that he hated it. That he wasn’t cut out for it in any manner, shape or form.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Which was why he’d been searching through the Seattle classifieds this Sunday morning, looking at the section that listed businesses for sale and trying to figure out what to do with himself other than making the electric company rich by pumping electricity through every room of the empty house. The house where he and his brother and sisters had grown up in.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What you need, boy, is a fine-looking woman to take your mind off everything.” That had been Nathan’s solution, delivered sagely over a mug of ale.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Fine-looking women were Nathan’s solution to everything, up to and including global warming and the threat of an alien invasion. However, that wasn’t his solution, Kevin thought. Not even remotely.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He got up and shut off the television set and picked up the classifieds again. Maybe there was something he’d missed the first time.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_vm._v("Looks had never meant anything to him. Heart did. ")]), _c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_vm._v("Heart and soul and patience. But all the women he’d known possessing those qualities had been taken long before now.")])]), _c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Besides, there wasn’t much chance of a woman like that showing up at his door, and that would be the only way he’d run into one. He didn’t believe in any of the conventional ways of “hooking up” with members of the fairer sex. That had never been his way. And now that he no longer occasionally drove a cab, there was absolutely no chance of his meeting anyone.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Kevin paused, trying to remember the last time he’d actually gone out on a date. Nothing came to him.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But dating, or finding a lifelong partner wasn’t why he was looking to put his newfound fortune into another business. He just wanted to be doing something. Something productive.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Anything")]), _vm._v(" productive.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He’d been out of the taxicab business for exactly five days and was going stir-crazy.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The phone rang and he grabbed the receiver like a drowning man grabbing at a twig floating by him in the river.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("If it was a telemarketer on the other end, he thought, this was their lucky day. He was buying, as long as buying meant he could hear the sound of another person’s voice responding to his own.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Hello?”")])]), _c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Kev?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Kevin could feel himself lighting up inside like a Christmas tree the instant he heard his sister’s voice on the other end of the line.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Lily, how are you?” He bit back the desire to ask the next question that loomed in his mind in twenty-four-foot neon letters: Are you coming home? He already knew the answer to that. Asking wasn’t going to change it.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m terrific, Kev. Better than terrific, I’m spectacular.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He didn’t have to see her to know that she was positively glowing. So much for her throwing in the towel and deciding to move back to Seattle.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("There was something else in her voice he recognized as well. “You’re getting married, aren’t you?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("There was a slight pause on the other end of the line. “God, but you’re good. How did you—?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A small laugh escaped him. “I’ve had this conversation before. Twice,” he reminded her. “When Alison called to say she was marrying Luc and when Jimmy called to say he was staying on as a doctor in Hades and, oh, by the way, yes, he was getting married.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_vm._v("If Jimmy, a guy known to his friends as the eternal happy bachelor could succumb to the charms of a homegrown native, Kevin had known in his heart that Lily wasn’t far behind. Especially when she’d called before to give him a detailed description of Max ")]), _c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_vm._v("Yearling right down to his worn, size-ten boots. It was only a matter of waiting for the shoe to finally drop, that’s all.")])]), _c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Kevin knew he was happy for her, even as he was sad for himself. He did his best to sound cheerful. “So the sheriff makes you happy, does he?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Lily sighed, contentment of a caliber he didn’t ever recall hearing before in her voice. “The way you wouldn’t believe.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Kevin felt his mouth curving in a grin. “I don’t need details, Lily.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“And you’re not getting any,” she informed him with a laugh. “But I want you to come up here. For the wedding. It’s in three weeks and I wouldn’t feel as if it’s official unless you’re here to give me away.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He refrained from saying that no one had ever held on to her long enough to pretend that she was his to give away. Lily had been her own person from a very early age.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Yes, he thought, he really was going to miss her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’d be proud to, Lily.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He heard her clear her throat. Lily hated to get sentimental. “Now I know how you feel about getting away from the business, but maybe Nathan or Joe could take over while—”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_vm._v("He cut her off briskly. “Not a problem. I sold the business.” In response, he heard nothing but silence on the other end. Everything had happened so quickly he hadn’t even had time to tell any of them that he ")]), _c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_vm._v("was thinking about selling, much less that he’d signed on the dotted line and made Quintano Cabs a thing of the past. “Lily, are you there?”")])]), _c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He heard her take in a sharp breath. “Yes, I guess the connection just went weird for a second. I thought I heard you say—”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He didn’t want to hear her say it. He couldn’t exactly explain why hearing one of his siblings give voice to what he’d done would make it that much more difficult to bear, but it did. “You did. I did.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“But, Kevin, why?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The last thing he wanted to do now was discuss what he’d impulsively done over the telephone. He needed to reconcile himself to today’s wrinkle first, then think about his late business.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Seemed like the thing to do at the time.” He changed the topic. “Anyway, three weeks, eh? That’s really short notice. You’ve got a lot to do before then.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I know.” She sighed, as if trying to brace herself for what lay ahead. “I can manage—”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He suddenly knew what to do with himself. At least, for the next three weeks. “Especially with help. I’ll come up early.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“How early?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_vm._v("Unless he missed his guess, he’d managed to stun Lily twice in the space of two minutes. “I’m not doing anything right now. I’ll be there as soon as possible.” He was already walking toward the cabinet ")]), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_vm._v("where he kept the phonebooks stashed. “Let me book a flight and then I’ll get back to you.”")])]), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Still very numb, Lily murmured a half-audible “Okay.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Great. Talk to you later. Bye.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The line went dead. Lily let the receiver drop slowly as she turned around to face the rest of her family who were gathered in the room around her. Her brother and sister were there with their spouses, as well as Max and June, who absolutely refused to be left out of anything, family oriented or otherwise. Alison and Jimmy looked at her in surprise, clearly disappointed that they didn’t each get a chance to talk to Kevin on the phone.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Closest to her, Jimmy stared at the medical clinic telephone, one of the few in Hades that didn’t still possess a rotary dial. He raised his eyes to hers in protest. “You hung up.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“He hung up first,” Lily muttered, still staring at the receiver and feeling as if a piece of the known world had just disappeared from her life.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Max came around to face her. “Lily, what’s the matter? Isn’t your brother coming?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Slowly she nodded her head. Sold, the business was sold. Gone. Wow. She would have thought that the Space Needle would have wound up on eBay for an auction before Kevin would ever even consider selling the taxicab service.")])]), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Oh, he’s coming all right.” Raising her eyes, she looked at the others.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Then what’s the matter?” Max asked.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Lily’s eyes met his. “Kevin just told me he’s sold the business.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“He did what?” Jimmy’s jaw went slack. He’d put in seven summers driving one of Kevin’s cabs. It was as if a member of the family had died")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Lily turned to look at him. “Sold the business.” Unable to fathom it, she waved her hand vaguely in the air. “Said it seemed like the thing to do.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She looked from one face to another as if waiting for one of them to unravel the mystery for her, to make sense of the situation. Why would Kevin do that? He "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("loved")]), _vm._v(" the business.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("June Yearling lifted her slender shoulders, wondering what the big deal was all about. People sold businesses every day. She had, just recently. The one-time owner of the only auto-repair shop in over a hundred-mile radius, she’d sold the business that had been passed on to her, because it had felt like the right thing to do at the time.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Maybe it was,” she said to her brother’s fiancée. “Maybe he has an itch, and selling his taxicab service is the only way he knows how to scratch it.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_vm._v("Lily sighed. It still didn’t make any sense to her. Kevin was acting rashly, especially for Kevin. Why hadn’t he discussed this with any of them? She looked ")]), _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_vm._v("at Jimmy and Alison, but they looked as mystified as she was.")])]), _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Lily ran her hands up and down her arms, despite the fact that the day was warm. “But he’s had that business forever.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("June thought of herself, of her own feelings when she’d made up her mind to sell. “Forever’s a long time. Maybe he needed something new. Maybe he got tired of having things break down on him and—” She bit her lip, realizing that she’d allowed her own experiences to intrude into her interpretation. “Sorry. They always say, stick to what you know.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Max laughed shortly, shaking his head. She might have the face of an angel, but June was the wild one in the family, especially now that April had ceased her wandering ways and returned to live in Hades. June had never made noises about moving out of state, the way over three-quarters of the adolescent population had, but she had been a restless pistol in every other way. She was always full of surprises.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“If that were the case,” he said to her, “you wouldn’t have sold the shop to Walter Haley and announced that you were going to make a go of the family farm.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Family farm.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_vm._v("It was almost a euphemism at this point. In reality, it had been abandoned land for years. They’d left it without any thought when he, Alison and June, along with their mother, had moved in with their grand")]), _c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_vm._v("mother after their father had taken off for parts unknown. The thought of making a go of the property had vaguely crossed his mind, only to be quickly discarded. The town needed a sheriff and he needed to be it. Max knew he was lucky enough to have found his true calling.")])]), _c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("June frowned, looking down at her hands. They were scrubbed clean now, but there were still traces of dark stains on them. She’d never been one to dress up or try to compete with her sister, or any of the other girls in town, but even she had a place where she drew the line.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I got tired of trying to get motor oil off my hands,” she retorted. She looked accusingly at the older brother she secretly adored. “A woman’s got a right to want to keep her hands clean.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Max gave her an innocent look. “Never said otherwise.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Concern creased Alison’s fair features as she looked at her own brother. “Think Kevin’s having a midlife crisis?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Luc laughed at his wife’s suggestion, shaking his head. He’d always liked Kevin. “Thirty-seven’s a little young to have a midlife crisis.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("June looked at him. She might be the youngest in the room, but age to her was not a brittle thing, without rounded edges or flexibility. “Seems to be just about right to me. Unless he’s planning on living until he’s a hundred.”")])]), _c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Jimmy smiled, remembering the promise Alison had extracted from their brother after their father’s funeral. “Kevin is planning on living forever.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Well, then you’re right,” she said glibly. “Thirty-seven’s too young for a midlife crisis. Maybe he just needed a change.” With the bluntness of the very young, she looked at Kevin’s siblings. “After all, you all picked up and left him.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It almost sounded like an accusation. Lily exchanged glances with Jimmy.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“None of us planned it that way,” Alison protested for all of them.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("June shrugged. She had to be getting back to work. The land wasn’t going to tend itself. And she still had cows to milk and a disabled tractor to curse. “Still, that’s what happened. Maybe he thinks it’s time to start over.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Jimmy looked thoughtful. Maybe June had stumbled across something. “In Kevin’s case, it’s starting life in the first place. He’s never had time for a life,” he told his in-laws. “Been there for all of us and never had time to be there for himself.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("June looked triumphant. “Mystery solved,” she announced. “This is his time for himself.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Alison tried to keep the sad feeling at bay, but it insisted on coming. She looked at Jimmy. “Still, it feels kind of weird, knowing the taxi service is gone.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_vm._v("Jimmy nodded his agreement. All three of them ")]), _c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_vm._v("had taken turns putting in time at the service and driving a cab, even Lily. Driving a cab was how Alison had met Luc in the first place. Luc had come down from Hades, looking for someone to pretend to be his wife in order to cover an inadvertent white lie. He’d wound up saving Alison from a mugger and sustaining a concussion. To pay him back for his trouble, especially after she’d discovered the nursing shortage in Hades, Alison had agreed to the charade and stayed on to play the part in earnest.")])]), _c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Crossing to the door, June placed her hand on the latch.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Probably no weirder than he’s feeling with all of you gone.” She opened the door. “Well, I’ve got to be getting back to work. I’ll see you all later.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Max shook his head as June closed the door. He put his arms around Lily, giving her a hug to stave off the bout of guilt he saw in her eyes. “Always said June was the cheerful one in the family.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Jimmy looked after his sister-in-law thoughtfully. The last time Kevin had come up here, it had been to take part in his wedding. At twenty, June had seemed too young at the time. She wasn’t too young now.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Maybe that’s what we can do to get Kevin’s mind off whatever’s really bothering him.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Do?” Lily echoed. “Do what? What are you talking about?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_vm._v("But Alison was already on Jimmy’s wavelength. “We’ll tell Kevin that June needs cheering up.” She ")]), _c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_vm._v("brightened immensely. “Kevin’s at his best when he’s dealing with someone else’s problems.” She looked at the others. “The man is a problem solver. He misses having to deal with all our baggage.”")])]), _c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Lily sniffed. “We didn’t come with baggage.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Jimmy gave his older sister a pointed look. “You had your own luggage store.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She laughed shortly. “And Casanova didn’t?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Max grinned as he tightened his arms around his wife-to-be. “I’m beginning to understand what Kevin did in the family. He kept the peace.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Lily got off her high horse. Turning, she brushed a kiss against her future husband’s cheek.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’d say that gives Kevin something in common with you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Dealing with Lily was where his people-reading skills came in handiest—and were the most challenged. “I’m not flattering myself,” Max told her. “I keep the peace for any one of a number of residents here. I know better than to try to exercise control over you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“This marriage,” Jimmy announced to the others, “should work out just fine.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He ducked, but Max was quicker and caught Lily’s hand as she went to throw her cell phone at him.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yes,” Max agreed, looking at Lily meaningfully as he gently pushed her hand down again, “it should.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Lily’s eyes sparkled, negating the frown she was attempting to form.")])])]), _c('a', {
    attrs: {
      "id": "page23"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page23"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c19f8d90","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781426870378_ch01.vue
// module id = 81
// module chunks = 0